<ng-container *ngIf="vm$ | async as vm">
	<app-onboarding-container
		*ngIf="vm.currentStep"
		[imageUrl]="vm.currentStep.imageUrl"
		[headingText]="vm.currentStep.headingText"
		[subText]="vm.currentStep.subText"
		[paragraphText]="vm.currentStep.paragraphText"
		[playAnimation]="playAnimation"
		[alternativeText]="vm.currentStep.alternativeText"
	>
		<ng-container paragraph-content>
			<p>
				{{ vm.currentStep.subText }}
			</p>
			<p>
				{{ vm.currentStep.paragraphText }}
			</p>
		</ng-container>

		<ng-container cta-content>
			<ui-button
				preset="HIGH_EMPHASIS"
				[label]="vm.currentStep.nextActionText"
				class="flex"
				size="md"
				(click)="vm.currentStep.nextAction()"
			>
			</ui-button>

			<ui-button
				*ngIf="vm.currentStep?.backActionText"
				preset="LOW_EMPHASIS"
				[label]="vm.currentStep.backActionText"
				(click)="vm.currentStep.backAction()"
			>
			</ui-button>
		</ng-container>
	</app-onboarding-container>
</ng-container>
